// extracted by mini-css-extract-plugin
module.exports = {"block":"SelectItem_block__1o7hK","active":"SelectItem_active__1O_dY"};